<template>
    <div>
        <!-- TrustBox widget - Drop-Down -->
        <!-- <div v-if="showBig" class="trustpilot-widget" data-locale="da-DK" data-template-id="5418052cfbfb950d88702476" data-businessunit-id="4699216100006400050039dc" data-style-height="24px" data-style-width="100%" data-theme="dark" data-stars="4,5">
            <a href="https://dk.trustpilot.com/review/www.roverkob.dk" target="_blank" rel="noopener">Trustpilot</a>
        </div>
        <div v-if="showSmall" class="trustpilot-widget tablet" data-locale="da-DK" data-template-id="5418052cfbfb950d88702476" data-businessunit-id="4699216100006400050039dc" data-style-height="24px" data-style-width="220px" data-theme="dark" data-stars="4,5">
            <a href="https://dk.trustpilot.com/review/www.roverkob.dk" target="_blank" rel="noopener">Trustpilot</a>
        </div>  -->
        <!-- End TrustBox widget -->

    </div>
</template>

<script>
export default {
    // data(){
    //     return {
    //         showBig : false,
    //         showSmall : false
    //     }
    // },
    // mounted(){
    //     this.showBig = window.innerWidth > 1200;
    //     this.showSmall = !this.showBig;
    //     //https://support.trustpilot.com/hc/en-us/articles/115011421468-How-to-use-TrustBoxes-in-single-page-applications
    //     if(window["Trustpilot"]) // already inited
    //     {
    //         window.Trustpilot.loadFromElement(this.$refs.trustpilot);
    //     }
    // },
    // created(){
    //     if(location.href.indexOf("rendertron")>0)
    //         return;
    //     var sc = document.createElement("script");
    //     sc.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    //     // sc.setAttribute('crossorigin', 'anonymous');
    //     document.head.appendChild(sc);
    // }
}
</script>

<style scoped>
    /* .trustpilot-widget.tablet{
        margin-right:-45px;
    } */
</style>
